"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDuplicateRecipient = void 0;
var matchingFields = [
    'beneficiaryBankAccountCountry',
    'currencyTo',
    'businessName',
    'firstName',
    'lastName',
    'streetAddressUnitNumber',
    'streetAddressName',
    'streetAddressType',
    'city',
    'state',
    'postcode',
    'country',
    'email',
    'bicSwiftCode',
    'iban',
    'sortCodeNumber',
    'clabeNumber',
    'cnapsNumber',
    'abaCode',
    'bankName',
    'accountNumber',
    'ifscNumber',
];
var findDuplicateRecipient = function (recipientToFind, _a) {
    var recipientList = _a.recipientList;
    if (!recipientList || (recipientList && recipientList.length === undefined)) {
        throw Error('findDuplicateRecipient must have recipientList array');
    }
    if (typeof recipientToFind !== 'object') {
        throw Error('findDuplicateRecipient must have recipientToFind');
    }
    var duplicateRecipient = recipientList.find(function (recipient) {
        return !matchingFields.some(function (prop) { return "".concat(recipientToFind[prop] || '').trim().toLowerCase() !== "".concat(recipient[prop] || '').trim().toLowerCase(); });
    });
    return duplicateRecipient;
};
exports.findDuplicateRecipient = findDuplicateRecipient;
//# sourceMappingURL=index.js.map